// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/img/aboutheader.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".about-intro-image[data-v-0fa6660c]{background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");height:680px;margin-top:-70px;background-size:cover;background-position:bottom;background-repeat:no-repeat}@media only screen and (max-width:768px){.about-intro-image[data-v-0fa6660c]{height:100vh;margin-top:-80px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
